import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useAffirmRefreshHTML from 'hooks/useAffirmRefreshHTML';
import React from 'react';

const CartAffirmSection = ({
  affirmButtonRef,
  handleFinancingClick,
  orderTotal,
}) => {
  const showLearnMoreButton = useAffirmRefreshHTML(affirmButtonRef);

  return (
    <div className="[--color-brand:#107c8c] [&_a]:text-brand [&_a]:border-b [&_a]:border-solid [&_a]:border-brand [&_a]:pb-0.5 [&_a:hover]:[border-bottom:0] py-[22px] px-[5px] text-left md:text-center text-sm text-gray border-b border-solid border-gray-light7 md:border-b-0 m-0 md:m-[unset]">
      From $
      {orderTotal <= 1499
        ? Math.round(orderTotal / 12)
        : Math.round(orderTotal / 18)}
      /mo for {orderTotal <= 1499 ? 12 : 18} months at 0% APR.{' '}
      {showLearnMoreButton && (
        <CtaButton
          aria-label="Learn more about monthly payment options"
          block
          color="brand"
          hasArrow={false}
          onClick={handleFinancingClick}
          size="sm"
          styling="link"
          title="Learn more about monthly payment options"
        >
          Learn more
        </CtaButton>
      )}
      <div style={{ display: 'none' }}>
        <div
          type="button"
          ref={affirmButtonRef}
          className="affirm-as-low-as"
          data-page-type="cart"
          data-amount={(orderTotal * 100).toString()}
        >
          Apply Now
        </div>
      </div>
    </div>
  );
};

CartAffirmSection.propTypes = {
  affirmButtonRef: PropTypes.object,
  handleFinancingClick: PropTypes.func,
  orderTotal: PropTypes.number,
};

export default CartAffirmSection;
